var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t("common.table.ask"))+":")]),_vm._v(_vm._s(_vm.monitorItem.priceAsk.toFixed(_vm.monitorItem.digits))+" ")]),_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t("common.table.bid"))+":")]),_vm._v(_vm._s(_vm.monitorItem.priceBid.toFixed(_vm.monitorItem.digits))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }